module.exports = __webpack_public_path__ + "img/fconnect.547014bc.png";